import * as React from "react";
import "styles/dmm.scss";

export const DmmHeader = () => {
    const MobileHeader = React.useMemo(
        () => (
            <header>
                <a href="https://games.dmm.co.jp/" className="ntg-top">
                    FANZA GAMES
                </a>
                <div className="navi-right">
                    <a
                        href="https://point.dmm.co.jp/choice/pay?basket_service_type=freegame"
                        className="arrow"
                    >
                        ポイントチャージ
                    </a>
                </div>
            </header>
        ),
        []
    );
    const Header = React.useMemo(
        () => (
            <div id="dmm_ntgnavi">
                <ul className="navi_left">
                    <li className="ntg_top">
                        <a href="https://games.dmm.co.jp/">
                            <span>FANZA GAMESトップ</span>
                        </a>
                    </li>
                    <li className="ntg_poi">
                        <a
                            href="https://point.dmm.co.jp/choice/pay?basket_service_type=freegame"
                            target="_blank"
                        >
                            <span>ポイントチャージ</span>
                        </a>
                    </li>
                </ul>
                <ul className="navi_right">
                    <li>
                        <a
                            href="https://www.dmm.co.jp/netgame/top/guide/startguide_html/=/ch_navi=/"
                            className="arrow"
                        >
                            初めての方
                        </a>
                    </li>
                </ul>
                <div className="clear"></div>
            </div>
        ),
        []
    );

    return (
        <div className="dmm-header-container bg-white">
            <div className="lg:hidden">{MobileHeader}</div>
            <div className="hidden lg:block">{Header}</div>
        </div>
    );
};
